import * as React from 'react';
import classes from './ActionMenu.module.scss';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { SquareButton } from '../../../components/actions/SquareButton';
import { RightDrawerTypeEnum } from '../../../constants/right-drawer';
import { RightDrawerContext, RightDrawerToggleHandler } from '../../../providers/AppProvider';
import { Tooltip } from '../../../components/actions/Tooltip';
import { useSubscriptionStatus } from 'hooks/useSubscriptionStatus';

export type ActionMenuViewProps = {
  toggleRightDrawer: RightDrawerToggleHandler;
  unreadNotifications?: number;
  rightDrawerState: RightDrawerContext;
};

export const ActionMenuView = (props: ActionMenuViewProps): JSX.Element => {
  const { isAccessBlocked } = useSubscriptionStatus();
  let actionButtonItems = [
    {
      id: 1,
      icon: SquareButtonIconsEnum.notification,
      type: RightDrawerTypeEnum.notifications,
      badge: props.unreadNotifications,
      tooltipText: 'Notifications'
    },
    {
      id: 2,
      icon: SquareButtonIconsEnum.help,
      type: RightDrawerTypeEnum.help,
      tooltipText: 'Help'
    },
    {
      id: 3,
      icon: SquareButtonIconsEnum.settings,
      type: RightDrawerTypeEnum.settings,
      tooltipText: 'Settings'
    }
  ];
  if (isAccessBlocked) {
    actionButtonItems = [{
      id: 3,
      icon: SquareButtonIconsEnum.settings,
      type: RightDrawerTypeEnum.settings,
      tooltipText: 'Settings'
    }]
  }
  return (
    <div className={`grid-x grid-padding-x ${classes.ActionMenu}`}>
      {actionButtonItems.map((item, index) => (
        <div className={'cell shrink'} style={{ zIndex: actionButtonItems.length - index }} key={item.id}>
          <Tooltip type={'regular'} target={`#${item.tooltipText}`}>
            {item.tooltipText}
          </Tooltip>
          <SquareButton
            id={`${item.tooltipText}`}
            type={'white'}
            action={e => {
              e.stopPropagation();
              props.toggleRightDrawer(item.type);
            }}
            icon={item.icon}
            badge={item.badge}
            active={(props.rightDrawerState?.open && props.rightDrawerState?.type === item.type) ?? false}
          />
        </div>
      ))}
    </div>
  );
};
